import type { Milestone, Tier } from "../../types";
import nameLevels from "./nameLevels";
import type { Action, Status } from "./types";

type RawTier = Omit<Tier, "milestones"> & {
  milestones?: { edges?: { node: Milestone }[] };
};

const transformTier = (
  prevTier: Tier[],
  tierRaw: Status["tiers"] | undefined,
): Tier[] => {
  const list = tierRaw?.edges; // My tiers
  if (!list || !list?.length) {
    return prevTier;
  }

  const ret = new Map<string, Tier>();

  for (const n of prevTier) if (n?.id) ret.set(n.id, n);
  for (const { node } of list as { node: RawTier }[])
    if (node?.id) {
      const id = atob(node.id);
      const prev = ret.get(id);
      ret.set(id, {
        ...prev,
        ...node,
        id,
        // The CMS name is translated: it wins over the API's, whichever loads last.
        name: prev?.hasCms && prev.name ? prev.name : node.name,
        milestones: nameLevels(
          node.milestones?.edges?.map((edge) => edge.node) || [],
          prev?.levels,
        ),
      });
    }

  return [...ret.values()].sort((a, b) => (a.points ?? 0) - (b.points ?? 0));
};

// To fetch the progress i get the last in order milestone
const fetchProgress = (
  myStatus:
    | (Status["myStatus"] & { currentTier?: { totalProgress?: number } })
    | undefined,
) => {
  if (!myStatus) {
    return 0;
  }

  if (
    myStatus?.nextMilestone?.progress &&
    typeof myStatus?.nextMilestone?.progress === "number"
  ) {
    return myStatus?.nextMilestone?.progress;
  }

  if (
    myStatus?.currentTier?.totalProgress &&
    typeof myStatus?.currentTier?.totalProgress === "number"
  ) {
    return myStatus?.currentTier?.totalProgress;
  }

  return 0;
};

const loadStatus: Action<"statusLoaded"> = (state, msg, payload) => {
  const data = msg?.status;
  if (!data) return state;

  const currentTier =
    data?.myStatus?.currentTier?.id &&
    atob(data.myStatus.currentTier.id)?.replace?.(
      "LoyaltyPublicUserTier",
      "LoyaltyPublicTier",
    );

  return {
    ...state,
    error: false,
    tiers: transformTier(state.tiers, data?.tiers),
    currentTier,
    progress: fetchProgress(data?.myStatus),
    currentPoints: data?.myStatus?.tierPoints,
    button: {
      ...state.button,
    },
    visibility: {
      ...state.visibility,
    },
  };
};

export default loadStatus;
